import './AppLayout.less';
import * as React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import Header from '../../components/Header';
import { Layout } from 'antd';
import ProtectedRoute from '../../components/Router/ProtectedRoute';
import { appRouters } from '../Router/router.config';
import utils from '../../utils/utils';
import NotFoundRoute from '../Router/NotFoundRoute';
import Stores from '../../stores/storeIdentifier';
import { inject, observer } from 'mobx-react';
import SessionStore from '../../stores/sessionStore';
import SiderMenu from '../SiderMenu';
import { GetCurrentLoginInformations } from '../../services/session/dto/getCurrentLoginInformations';
import UserStore from '../../stores/userStore';
import CommunicationStore from '../../stores/communicationStore';
import IntegrationStore from '../../stores/integrationStore';
import InventoryStore from '../../stores/inventoryStore';
import MenuStore from '../../stores/menuStore';
import PaymentsStore from '../../stores/paymentStore';
import PeopleStore from '../../stores/peopleStore';
import ReportStore from '../../stores/reportStore';
import RoleStore from '../../stores/roleStore';
import SchedulingStore from '../../stores/schedulingStore';
import TeamStore from '../../stores/teamStore';
import WorkOrderStore from '../../stores/workOrderStore';
import InfoHubStore from '../../stores/infohubStore';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

declare var abp: any;

export interface IAppLayoutProps {
  sessionStore: SessionStore;
  userStore: UserStore;

  communicationStore: CommunicationStore;
  inventoryStore: InventoryStore;
  menuStore: MenuStore;
  paymentStore: PaymentsStore;
  peopleStore: PeopleStore;
  reportStore: ReportStore;
  roleStore: RoleStore;
  schedulingStore: SchedulingStore;
  teamStore: TeamStore;
  workOrderStore: WorkOrderStore;
  integrationStore: IntegrationStore;
  infoHubStore: InfoHubStore;
}

export interface IAppLayoutState {

  collapsed: boolean;
  headerLoading: boolean;
  currentUserID: number;
  currentLoginName: string;
  currentLoginLastName: string;
  profileImageID: number;
  profileImageURL: string;
  currentUsername: string;
  currentEmailAddres: string;
  hasCreatePermissions: boolean;
  currentTenantName: string;
  primaryTenantColor: string;
  secondaryTenantColor: string;
  hasWidgetPermissions: boolean;
  tenantImageID: number;
  tenantImageURL: string;
  tenantTitle: string;
  subscriptionType: any;
  tenantSubscriptionStart: string;
  tenantSubscriptionEnd: string;
  tenantSubscriptionActive: boolean;
  roles: string[];
  currentLoginFirstName: string;
  availableTemplates: any;
  isMobile: boolean;
}

const { Content } = Layout;

@inject(Stores.SessionStore,
  Stores.UserStore,
  Stores.InfoHubStore,
  Stores.CommunicationStore,
  Stores.InventoryStore,
  Stores.MenuStore,
  Stores.PaymentStore,
  Stores.PeopleStore,
  Stores.ReportStore,
  Stores.RoleStore,
  Stores.SchedulingStore,
  Stores.TeamStore,
  Stores.WorkOrderStore,
  Stores.IntegrationStore)
@observer
class AppLayout extends React.Component<any, IAppLayoutState> {


  state = {
    isMobile: false,
    hasCreatePermissions: false,
    hasWidgetPermissions: false,
    availableTemplates: '',
    headerLoading: true,
    collapsed: true,
    subscriptionType: -1,
    roles: [],

    currentUserID: 0,
    currentLoginName: '',
    currentLoginLastName: '',
    currentLoginFirstName: '',
    profileImageID: 0,
    profileImageURL: '',
    currentUsername: '',
    currentEmailAddres: '',

    currentTenantName: '',
    primaryTenantColor: '#dadada',
    secondaryTenantColor: '#dadada',

    tenantImageID: 0,
    tenantImageURL: '',
    tenantTitle: '',

    tenantSubscriptionStart: '',
    tenantSubscriptionEnd: '',
    tenantSubscriptionActive: false,

  };

  async componentDidMount() {

    this.setState({ headerLoading: true });

    await this.props.sessionStore!.getCurrentLoginInformations();
    var currentLoginInfo: GetCurrentLoginInformations = this.props.sessionStore!.currentLogin;

    this.setState({

      currentLoginName: currentLoginInfo.user.name,
      currentLoginLastName: currentLoginInfo.user.surname,
      profileImageID: currentLoginInfo.user.profileImageID,
      profileImageURL: currentLoginInfo.user.profileImageURL,
      currentUsername: currentLoginInfo.user.userName,
      currentEmailAddres: currentLoginInfo.user.emailAddress,
      currentTenantName: currentLoginInfo.tenant.title,
      primaryTenantColor: currentLoginInfo.tenant.primaryColor,
      secondaryTenantColor: currentLoginInfo.tenant.secondaryColor,
      tenantImageID: currentLoginInfo.tenant.profileImageID,
      tenantImageURL: currentLoginInfo.tenant.profileImageURL,
      tenantTitle: currentLoginInfo.tenant.title,
      tenantSubscriptionStart: 'Sandbox',
      tenantSubscriptionEnd: 'Sandbox',
      tenantSubscriptionActive: currentLoginInfo.tenant.subscriptionActive,
      roles: currentLoginInfo.roles,
      currentUserID: currentLoginInfo.user.userID,
      hasCreatePermissions: currentLoginInfo.user.hasCreatePermission,
      hasWidgetPermissions: currentLoginInfo.user.hasWidgetPermission,
      subscriptionType: 'Sandbox',
      availableTemplates: 'Unlimited'

    });


    if (this.state.tenantImageURL === '') {

      let profileImage = await this.props.userStore!.getProfileImage(currentLoginInfo.tenant.profileImageID);

      if (profileImage === '_') {
        this.setState({ profileImageURL: currentLoginInfo.tenant.profileImageURL })
      }
      else {
        this.setState({ tenantImageURL: profileImage })
      }
    }

    this.setState({ headerLoading: false });

    if (this.state.profileImageURL === '') {

      let profileImage = await this.props.userStore!.getProfileImage(currentLoginInfo.user.profileImageID);

      if (profileImage === '_') {
        this.setState({ profileImageURL: currentLoginInfo.user.profileImageURL })
      }
      else {
        this.setState({ profileImageURL: profileImage })
      }
    }

    if (window.innerWidth >= 550) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

    window.addEventListener('resize', this.handleResize)

  }

  handleResize = () => {

    if (window.innerWidth >= 550) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

  }

  render() {
    const {
      history,
      location: { pathname },
    } = this.props;

    const { path } = this.props.match;
    const { collapsed } = this.state;

    const layout = (
       
      <Layout   style={{ background: '##f5f5f5' }}>
       
          <SiderMenu
            currentLoginInfo={this.props.sessionStore!.currentLogin}
            loading={this.state.headerLoading}
            userImageURL={this.state.profileImageURL}
            secondaryColor={this.state.secondaryTenantColor}
            primaryColor={this.state.primaryTenantColor}
            path={path}
            history={history}
            collapsed={collapsed} />

          <Layout>




            <Layout.Header style={{ margin: 'auto', minHeight: 52, background: '#f5f5f5' }}>
              <Header 
                history={history} 
                isMobile={this.state.isMobile}
                subscriptionType={this.state.subscriptionType}
                subscriptionStart={this.state.tenantSubscriptionStart}
                subscriptionEnd={this.state.tenantSubscriptionEnd}
                availableTemplates={this.state.availableTemplates}
                userEmail={this.state.currentEmailAddres}
                userFirstName={this.state.currentLoginName}
                userLastName={this.state.tenantTitle}
                hasCreatePermissions={this.state.hasCreatePermissions}
                hasWidgetPermissions={this.state.hasWidgetPermissions}
                currentLoginName={this.state.currentLoginName}
                userStore={this.props.userStore}
                dataTableImage={this.state.tenantImageURL} 
                communicationStore={this.props.communicationStore}
                inventoryStore={this.props.inventoryStore}
                menuStore={this.props.menuStore}
                paymentStore={this.props.paymentStore}
                peopleStore={this.props.peopleStore}
                roleStore={this.props.roleStore}
                reportStore={this.props.reportStore}
                schedulingStore={this.props.schedulingStore}
                teamStore={this.props.teamStore}
                workOrderStore={this.props.workOrderStore}
                integrationStore={this.props.integrationStore}
                profileID={this.state.profileImageID}
                headerLoading={this.state.headerLoading}
                currentName={this.state.currentLoginName}
                userID={this.state.currentUserID}
                tenantName={this.state.currentTenantName}
                profileImageURL={this.state.tenantImageURL}
                primaryColor={this.state.primaryTenantColor}
                secondaryColor={this.state.secondaryTenantColor}
                location={path}
                username={this.state.currentUsername}
                collapsed={this.state.collapsed}
                currentRoles={this.state.roles} />
            </Layout.Header>





            <Content style={{ margin: 16, background: 'transparent' }} >

              <Switch>
                {pathname === '/' && <Redirect from="/" to="/dashboard" />}
                {appRouters
                  .filter((item: any) => !item.isLayout)
                  .map((route: any, index: any) => (
                    <Route

                      exact
                      key={index}
                      path={route.path}
                      render={props =>
                        <ProtectedRoute
                          component={route.component}
                          permission={route.permission} />

                      }
                    />
                  ))}
                {pathname !== '/' && <NotFoundRoute />}
              </Switch>
            </Content>

          </Layout>
        
      </Layout>  
    );

    return <DocumentTitle title={utils.getPageTitle(pathname)}>{layout}</DocumentTitle>;
  }
}

export default AppLayout;
